<template lang="pug">
v-select.parcelleSelector(
  :items="items",
  label="MAPARCEL™",
  item-text="title",
  item-value="id",
  v-model="parcelleSelectorModel",
  hide-details,
  persistent-placeholder,
  placeholder="Selectionnez une parcelle",
  color="secondary"
)
</template>


<script>
export default {
  name: "parcellesSelector",
  props: ["items", "value"],
  computed: {
    parcelleSelectorModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
<style lang="stylus" scoped>
.parcelleSelector {
  display: flex;
  flex: 1;
}</style>

